import React from 'react';
import Logo from './Logo';
import './footer.css';

const FOOTER_LINKS = [
  { label: '/ai-consulting', target: 'services' },
  { label: '/software', target: 'services' },
  { label: '/process', target: 'process' },
  { label: '/blog', href: '/blog' },
  { label: '/contact', target: 'contact' },
];

// Used when Footer is rendered outside AppContent (e.g. a standalone page).
const fallbackNavClick = (e, targetId) => {
  e.preventDefault();
  window.location.href = `/#${targetId}`;
};

function Footer({ handleNavClick = fallbackNavClick }) {
  return (
    <footer className="ak-footer">
      <Logo className="ak-footer-mark" />

      <div className="ak-footer-links">
        {FOOTER_LINKS.map((link) =>
          link.href ? (
            <a key={link.label} href={link.href}>
              {link.label}
            </a>
          ) : (
            <a
              key={link.label}
              href={`/#${link.target}`}
              onClick={(e) => handleNavClick(e, link.target)}
            >
              {link.label}
            </a>
          )
        )}
      </div>

      <p className="ak-footer-legal">
        <a href="mailto:hello@akeyreu.com">hello@akeyreu.com</a>
        {' · '}© 2023 Akeyreu LLC
      </p>
    </footer>
  );
}

export default Footer;
